<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>Lion</ion-title>
        <ion-buttons slot="start" @click="close" style="padding-left: 10px">
          <ion-icon
            icon="arrow-back-outline"
            size="large"
            color="medium"
          ></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen>
      <div class="app-bg" style="height: 100%; padding-top: 50px">
        <ion-slides
          v-if="true"
          pager="false"
          :options="slideOpts"
          ref="prodImages"
          class="ion-slides-prod-detail"
          @click="sliderClicked($event)"
        >
          <ion-slide
            v-for="(image, index) in imageToView.data"
            :key="index"
            style="border-radius: 10px;"
          >
            <img v-lazy="image.imagen" style="border-radius: 10px;" />
          </ion-slide>
        </ion-slides>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import effect from '@/tools/slide_effect'
import { __ } from '@/plugins/tools/lodash'

let plEffect = __.cloneDeep(effect.coverflowEffect)
plEffect.loop = false
export default {
  ionViewDidEnter() {},
  ionViewDidLeave() {},
  ionViewWillEnter() {},
  ionViewWillLeave() {},
  emits: ['close'],
  props: {
    imagep: { type: String, default: '/img/loader/image_loader.png' }
  },
  data() {
    return {
      slideOpts: plEffect,
      image: '',
      slideOpts1: {
        zoom: {
          maxRatio: 1
        }
      }
    }
  },
  computed: {
    imageToView() {
      return this.$store.getters['app/productImageToView']
    },
    swiper() {
      return this.$refs.prodImages.$el.swiper
    }
  },
  mounted() {},
  methods: {
    sliderClicked(event) {
      if (
        !event.target.classList.contains('swiper-pagination-bullet') &&
        !event.target.classList.contains('swiper-button-next') &&
        !event.target.classList.contains('swiper-button-prev')
      ) {
        let image = this.imageToView.data[this.swiper.realIndex].imagen

        this.zoomImage(image)
      }
    },
    async zoomImage(image) {
      this.$store.dispatch('app/imageToView', image)
      this.$router.push({ name: 'view-image' })
    },
    close() {
      this.$router.go(-1)
    }
  }
}
</script>
